<script>
export let currentRoute;
export let params;


import RegistrationsTable from 'components/views/my/program/elements/RegistrationsTable.svelte';
import ParentsTable from 'components/views/my/program/elements/ParentsTable.svelte';


import Tabs from 'components/views/my/program/elements/Tabs.svelte';
import HelpTabs from 'components/views/my/program/elements/HelpTabs.svelte';
import Loading from 'components/elements/Loading.svelte';
// import Error from 'components/elements/Error.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


import { auth } from 'store/index.js';


import { get } from 'svelte/store';
import { navigateTo } from 'svelte-router-spa';
import SvelteSeo from 'svelte-seo';
import tippy from 'sveltejs-tippy';



const program_instance_id = currentRoute.namedParams.program_instance_id;

const api_url = app_.env.API_URL;



const token = get(auth).token;



let active_tab = 'registrations';

let promise = getProgramInstance();


async function getProgramInstance() {

	const url = `${api_url}coaches/program-instance/${program_instance_id}`;

	const resp = await fetch(url, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const result = await resp.json();


	if (!resp.ok) {

		if (resp.status === 404) {
			navigateTo('/my/programs');
		}

		// if resp.status_code == 404 --> redirect
		throw new Error(result.detail);
		// redirect ... ?
		// if not coach of program!
	}

	return result;

}


let last_updated_promise = getLastUpdatedInfo()

async function getLastUpdatedInfo() {

	const url = `${api_url}coaches/program-instance/${program_instance_id}/last-updated`;

	const resp = await fetch(url, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const result = await resp.json();

	if (!resp.ok) {
		throw new Error(result.detail);
	}

	return result;

}




let registrations_promise = getRegistrations();

async function getRegistrations() {

	const url = `${api_url}coaches/program-instance/${program_instance_id}/registrations`;

	const resp = await fetch(url, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const result = await resp.json();


	if (!resp.ok) {
		throw new Error(result.detail);
	}

	return result;

}

</script>


<style>
	
:global(.msg-card):nth-child(2) {
	margin-top: -0.75rem !important;
}

</style>



<SvelteSeo
	title='View Program | AHG Coaches Portal'
	description='View Program!'
/>


{#await promise}

<Loading />

{:then program_instance}

<section class="hero bg-grey with-tabs--">

	<div class="hero-body">

		<div class="container">

 			<p class="hero-subtitle has-text-centered">
				{program_instance.program.name}
				<!-- replace '(Second Year) with 2012 or whatever just the birth_year' -->
				{#if program_instance.year_start === program_instance.year_end}
					{program_instance.year_start}
				{:else}
					{program_instance.year_start} - {program_instance.year_end}
				{/if}
			</p>

			<p class="hero-undertitle has-text-centered" style="margin-top: 0.75rem; font-size: 1.05rem;">
				{#await last_updated_promise}
				<i class="fas fa-circle-notch fa-spin"></i>
				{:then last_updated}
				<span style="text-decoration: underline;">Updated</span>:
				<span use:tippy={{content: `${last_updated.datetime_str} (Registrations)`, allowHTML: true, placement: 'bottom', arrow: false}}>{last_updated.timeago}<i class="far fa-info-circle" style="margin-left: 0.375rem; font-size: 0.90rem !important;"></i></span>
				<!-- &#183;
				<span use:tippy={{content: `${last_updated.offline_datetime_str} (Non-SportsEngine registrations)`, allowHTML: true, placement: 'bottom', arrow: false}}>(Offline) {last_updated.offline_timeago}<i class="far fa-info-circle" style="margin-left: 0.375rem; font-size: 0.90rem !important;"></i></span> -->
				{:catch error}
				<!-- ? -->
				{/await}
			</p>

		</div>

	</div>
	
</section>


{#await registrations_promise}

<Loading />

{:then registrations}


<section class="section" style="padding-top: 2rem; padding-bottom: 0rem;">

	<div class="container">

		<div class="columns is-variable is-centered">

			<div class="column is-12-desktop is-12-touch">

				<div class="columns is-variable is-vcentered is-4">

					<div class="column is-narrow">

						<Tabs bind:active_tab={active_tab} />

					</div>


					<!-- No watch video tab ... ? -->


					<!-- <div class="column is-narrow" class:is-hidden={active_tab != 'jerseys_form'}>

						{#if !jerseys_form_changes_to_be_saved}
						<span use:tippy={save_all_jerseys_disabled_props}>
							<span class="button is-blue is-small" class:is-hidden={active_tab != 'jerseys_form'} disabled>
								<span>Save All Jersey Changes</span>
							</span>
						</span>
						{:else if jerseys_form_changes_to_be_saved}
						<span use:tippy={save_all_jerseys_active_props}>
							<span class="button is-blue is-small" class:is-hidden={active_tab != 'jerseys_form'} on:click={saveAllJerseysInfo}>
								<span>{#if !saving_jerseys}Save All Jersey Changes{:else}Saving Jerseys{/if}</span>
								<i class="fas fa-circle-notch fa-spin" class:is-hidden={!saving_jerseys}></i>
							</span>
						</span>
						{/if}
					</div>

					<div class="column is-hidden-desktop is-hidden-tablet" class:is-hidden={active_tab != 'jerseys_form'}></div> -->

					<div class="column is-hidden-mobile">

					</div>

					<div class="column is-narrow">

						<HelpTabs {program_instance_id} />

					</div>

				</div>

			</div>

		</div>

	</div>

</section>


<section class="section" style="padding-top: 2rem;">

	<div class="container">

		<div class="columns is-variable is-centered">


			<div class="column is-12-desktop is-12-touch">

				<MsgCard msg_show={true} msg_text={`You have ${registrations.length} total registrations for this program (so far).`} msg_type={'error'} msg_forever={true}  />

				{#if active_tab === 'registrations'}
					<RegistrationsTable {registrations} />
				{:else if active_tab === 'parents'}
					<ParentsTable {registrations} />
				{/if}

			</div>


		</div>

	</div>

</section>

{:catch error}

<section class="section" style="padding-top: 1.5rem; padding-bottom: 0;">

	<div class="container">

		<MsgCard msg_show={true} msg_text={error.message} msg_type={'error'} msg_forever={true} />

	</div>

</section>

{/await}


{:catch error}

<section class="section" style="padding-top: 1.5rem; padding-bottom: 0;">

	<div class="container">

		<MsgCard msg_show={true} msg_text={error.message} msg_type={'error'} msg_forever={true} />

	</div>

</section>

{/await}



